import {
  AppEnvironment,
  CustomAPIService,
  ObjectTypes
} from 'drive-ui-packages';
import { LockStatus } from 'pages/AuthorizePaymentPage/types';
import type { CheckStatus, HeaderData, URLType } from './types';
import type { InvoiceState } from 'pages/VendorsTablePage/components/VendorsTable/types';

export const APP_ENV = (process.env.REACT_APP_ENV ??
  'develop') as AppEnvironment;

export const getAPIBaseUrlForPrintService = (env: AppEnvironment): string => {
  if (env === 'master') return 'https://api.connectcdk.com/api';
  return 'https://api-dit.connectcdk.com/api';
};

export const ENDPOINTS_API_ACC_BFF: CustomAPIService = {
  develop: 'dms-accounting-payments-bff/v1',
  stage: 'dms-accounting-payments-bff/v1',
  perf: 'dms-accounting-payments-bff/v1',
  master: 'dms-accounting-payments-bff/v1'
};

export const ENDPOINTS_API_ACC_BFF_V2: CustomAPIService = {
  develop: 'dms-accounting-payments-bff/v1/v2',
  stage: 'dms-accounting-payments-bff/v1/v2',
  perf: 'dms-accounting-payments-bff/v1/v2',
  master: 'dms-accounting-payments-bff/v1/v2'
};

export const ENDPOINTS_API_URL_VCC_BFF: CustomAPIService = {
  develop: 'dms-accounting-virtualcard-payment/v1',
  stage: 'dms-accounting-virtualcard-payment/v1',
  perf: 'dms-accounting-virtualcard-payment/v1',
  master: 'dms-accounting-virtualcard-payment/v1'
};

export const ENDPOINTS_API_ACC_SERVICE: CustomAPIService = {
  develop: 'dms-accounting-payments-service/v1',
  stage: 'dms-accounting-payments-service/v1',
  perf: 'dms-accounting-payments-service/v1',
  master: 'dms-accounting-payments-service/v1'
};

export const ENDPOINTS_API_ACC_PAYABLES: CustomAPIService = {
  develop: 'dms-accounting-payables/v1',
  stage: 'dms-accounting-payables/v1',
  perf: 'dms-accounting-payables/v1',
  master: 'dms-accounting-payables/v1'
};

export const ENDPOINTS_COMMON_BFF: CustomAPIService = {
  develop: 'dms-api-ui-common-bff/v1',
  stage: 'dms-api-ui-common-bff/v1',
  perf: 'dms-api-ui-common-bff/v1',
  master: 'dms-api-ui-common-bff/v1'
};

export const DEFAULT_BASE_URLS: Required<CustomAPIService> = {
  develop: 'https://api-dev.connectcdk.com/api',
  stage: 'https://api-stage.connectcdk.com/api',
  perf: 'https://api-perf.connectcdk.com/api',
  master: 'https://api.connectcdk.com/api',
  local: 'http://localhost:8080'
};

export const PAYMENT_REGISTER_URLS: CustomAPIService = {
  develop: 'https://app-dms-payment-register.app-dev.connectcdk.com',
  stage: 'https://app-dms-payment-register.app-stage.connectcdk.com',
  perf: 'https://app-dms-payment-register.app-perf.connectcdk.com',
  master: 'https://app-dms-payment-register.app.connectcdk.com'
};

export const ODP_URLS: CustomAPIService = {
  develop: 'https://app-dms-on-demand-payments.app-dev.connectcdk.com',
  stage: 'https://app-dms-on-demand-payments.app-stage.connectcdk.com',
  perf: ' https://app-dms-on-demand-payments.app-perf.connectcdk.com',
  master: 'https://app-dms-on-demand-payments.app.connectcdk.com'
};

export const COMMON_BFF_JWT_URLS: CustomAPIService = {
  develop: 'https://dms-ui-common-bff-jwt.na-dev.connectcdk.com',
  stage: 'https://dms-ui-common-bff-jwt.na-stage.connectcdk.com',
  perf: 'https://dms-ui-common-bff-jwt.na-perf.connectcdk.com',
  master: 'https://dms-ui-common-bff-jwt.na.connectcdk.com'
};

export const PAYMENTS_BFF_JWT_URLS: CustomAPIService = {
  develop: 'https://dms-accounting-payments-bff-jwt.na-dev.connectcdk.com',
  stage: 'https://dms-accounting-payments-bff-jwt.na-stage.connectcdk.com',
  perf: 'https://dms-accounting-payments-bff-jwt.na-perf.connectcdk.com',
  master: 'https://dms-accounting-payments-bff-jwt.na.connectcdk.com'
};

export const PAYMENTS_SERVICE_JWT_URLS: CustomAPIService = {
  develop: 'https://dms-accounting-payments-service-jwt.na-dev.connectcdk.com',
  stage: 'https://dms-accounting-payments-service-jwt.na-stage.connectcdk.com',
  perf: 'https://dms-accounting-payments-service-jwt.na-perf.connectcdk.com',
  master: 'https://dms-accounting-payments-service-jwt.na.connectcdk.com'
};

export const VIRTUALCARD_PAYMENT_JWT_URLS: CustomAPIService = {
  develop:
    'https://dms-accounting-virtualcard-payment-jwt.na-dev.connectcdk.com',
  stage:
    'https://dms-accounting-virtualcard-payment-jwt.na-stage.connectcdk.com',
  perf: 'https://dms-accounting-virtualcard-payment-jwt.na-perf.connectcdk.com',
  master: 'https://dms-accounting-virtualcard-payment-jwt.na.connectcdk.com'
};

export const PAYABLES_JWT_URLS: CustomAPIService = {
  develop: 'https://dms-accounting-payables-jwt.na-dev.connectcdk.com',
  stage: 'https://dms-accounting-payables-jwt.na-stage.connectcdk.com',
  perf: 'https://dms-accounting-payables-jwt.na-perf.connectcdk.com',
  master: 'https://dms-accounting-payables-jwt.na.connectcdk.com'
};
export const DEFAULT_BASE_JWT_URLS: Required<CustomAPIService> = {
  develop: 'https://dms-accounting-payables-jwt.na-dev.connectcdk.com',
  stage: 'https://dms-accounting-payables-jwt.na-stage.connectcdk.com',
  perf: 'https://dms-accounting-payables-jwt.na-perf.connectcdk.com',
  master: 'https://dms-accounting-payables-jwt.na.connectcdk.com',
  local: 'http://localhost:8080'
};

export const getIsJWTDisabled = (): boolean =>
  localStorage.getItem('JWT_FLAG') === undefined ||
  localStorage.getItem('JWT_FLAG') === null ||
  localStorage.getItem('JWT_FLAG') === 'false';

export const makeUrl = ({
  customBaseUrls,
  apiServicePaths,
  env
}: {
  customBaseUrls?: CustomAPIService | undefined;
  apiServicePaths?: CustomAPIService | undefined;
  env: 'local' | 'develop' | 'stage' | 'perf' | 'master';
}): string => {
  const isJWTDisabled = getIsJWTDisabled();
  const URL = isJWTDisabled ? DEFAULT_BASE_URLS : DEFAULT_BASE_JWT_URLS;
  const baseUrls = {
    ...URL,
    ...customBaseUrls
  };
  const baseUrl = baseUrls[env];
  if (!apiServicePaths) {
    return baseUrl;
  }
  return `${baseUrl}/${apiServicePaths[env]}`;
};

export const getURLSet = (
  isNotJWT: boolean,
  existingURLs: CustomAPIService,
  newURLs: CustomAPIService
): CustomAPIService => (isNotJWT ? existingURLs : newURLs);

export const getBaseUICommonBffUrls = (): CustomAPIService => {
  const isJWTDisabled = getIsJWTDisabled();
  return getURLSet(isJWTDisabled, DEFAULT_BASE_URLS, COMMON_BFF_JWT_URLS);
};

export const getBaseUIPaymentsBffUrls = (): CustomAPIService => {
  const isJWTDisabled = getIsJWTDisabled();
  return getURLSet(isJWTDisabled, DEFAULT_BASE_URLS, PAYMENTS_BFF_JWT_URLS);
};

export const getBaseUIPaymentsServiceUrls = (): CustomAPIService => {
  const isJWTDisabled = getIsJWTDisabled();
  return getURLSet(isJWTDisabled, DEFAULT_BASE_URLS, PAYMENTS_SERVICE_JWT_URLS);
};

export const getBaseUIVirtualCardPaymentUrls = (): CustomAPIService => {
  const isJWTDisabled = getIsJWTDisabled();
  return getURLSet(
    isJWTDisabled,
    DEFAULT_BASE_URLS,
    VIRTUALCARD_PAYMENT_JWT_URLS
  );
};

export const getBaseUIPayablesUrls = (): CustomAPIService => {
  const isJWTDisabled = getIsJWTDisabled();
  return getURLSet(isJWTDisabled, DEFAULT_BASE_URLS, PAYABLES_JWT_URLS);
};

const JWT_V2_PATHS: CustomAPIService = {
  develop: 'v2',
  stage: 'v2',
  perf: 'v2',
  master: 'v2'
};

export const generateCommonBffUrl = (): string => {
  const isJWTDisabled = getIsJWTDisabled();
  const apiServicePaths = isJWTDisabled ? ENDPOINTS_COMMON_BFF : undefined;

  return makeUrl({
    apiServicePaths,
    env: APP_ENV,
    customBaseUrls: getBaseUICommonBffUrls()
  });
};

export const generatePaymentsBffUrl = (): string => {
  const isJWTDisabled = getIsJWTDisabled();
  const apiServicePaths = isJWTDisabled ? ENDPOINTS_API_ACC_BFF : undefined;

  return makeUrl({
    apiServicePaths,
    env: APP_ENV,
    customBaseUrls: getBaseUIPaymentsBffUrls()
  });
};

export const generatePaymentsBffV2Url = (): string => {
  const isJWTDisabled = getIsJWTDisabled();
  const apiServicePaths = isJWTDisabled
    ? ENDPOINTS_API_ACC_BFF_V2
    : JWT_V2_PATHS;

  return makeUrl({
    apiServicePaths,
    env: APP_ENV,
    customBaseUrls: getBaseUIPaymentsBffUrls()
  });
};

export const generatePaymentsServiceUrl = (): string => {
  const isJWTDisabled = getIsJWTDisabled();
  const apiServicePaths = isJWTDisabled ? ENDPOINTS_API_ACC_SERVICE : undefined;
  return makeUrl({
    apiServicePaths,
    env: APP_ENV,
    customBaseUrls: getBaseUIPaymentsServiceUrls()
  });
};

export const generatePaymentsVccBffUrl = (): string => {
  const isJWTDisabled = getIsJWTDisabled();
  const apiServicePaths = isJWTDisabled ? ENDPOINTS_API_URL_VCC_BFF : undefined;

  return makeUrl({
    apiServicePaths,
    env: APP_ENV,
    customBaseUrls: getBaseUIVirtualCardPaymentUrls()
  });
};

export const generatePayablesUrl = (): string => {
  const isJWTDisabled = getIsJWTDisabled();
  const apiServicePaths = isJWTDisabled
    ? ENDPOINTS_API_ACC_PAYABLES
    : undefined;

  return makeUrl({
    apiServicePaths,
    env: APP_ENV,
    customBaseUrls: getBaseUIPayablesUrls()
  });
};

export const ODP_URL = makeUrl({
  customBaseUrls: ODP_URLS,
  env: APP_ENV
});

export const PAYMENT_REGISTER_URL = makeUrl({
  customBaseUrls: PAYMENT_REGISTER_URLS,
  env: APP_ENV
});

export const URL_ROUTES: URLType = {
  apSchedule: '/ap-payments/schedule',
  landingPage: '/ap-payments',
  odcPage: ODP_URL,
  registerPage: PAYMENT_REGISTER_URL
};

export const MFE_URLS: URLType = {
  apSchedule: '/accounting/ap-payments/schedule',
  landingPage: '/accounting/ap-payments',
  odcPage: '/accounting/on-demand-payments',
  registerPage: '/accounting/payment-register'
};

export const DEFAULT_HEADER_DATA: HeaderData = {
  'x-department-name': '',
  'remote-user': '',
  'x-enterprise-id': '',
  'x-store-id': '',
  authorization: '',
  'Content-Type': 'application/json',
  'x-department-type': 'A'
};

export const LOCK_STATUS_MAP = {
  [LockStatus.LOCKED]: 'lock',
  [LockStatus.UNLOCKED]: 'unlock'
};

export const IAM_HA_TOKEN_URLS: Record<string, string> = {
  local: 'https://cml-api-nginx.global-dit.connectcdk.com/token',
  develop: 'https://cml-api-nginx.global-dit.connectcdk.com/token',
  stage: 'https://cml-api-nginx.global-dit.connectcdk.com/token',
  perf: 'https://nginx.nebula-perf.connectcdk.com/api/cs-common-login-api/v1/token',
  // PROD url is not available yet so the iamHaEnabled Harness flag should be kept OFF in prod. CAR-829 will address prod HA IAM change
  master: 'https://cml-api-nginx.global.connectcdk.com/token'
};

export const OKTA_OIDC_SCOPE = ['openid', 'profile', 'email'];

export const PATHS = {
  getAccountingUserData: (): string => `${generateCommonBffUrl()}/user/details`,
  getAuthorizeVccPay: (): string =>
    `${generatePaymentsVccBffUrl()}/virtual-card/payment`,
  getAccountingVirtualCardPayment: (): string =>
    `${generatePaymentsVccBffUrl()}/virtual-card/reconciliation-report`,
  getAccountingVirtualCardPaymentVoid: (): string =>
    `${generatePaymentsVccBffUrl()}/virtual-card/void`,
  getAccountingVirtualCardPaymentStatus: (): string =>
    `${generatePaymentsVccBffUrl()}/virtual-card/update-virtual-card-status`,
  getAccountingVirtualCardPdfGeneration: (): string =>
    `${generatePaymentsVccBffUrl()}/virtual-card/documentNumber`,
  getGlPostingValidation: (): string =>
    `${generatePaymentsVccBffUrl()}/virtual-card/gl-validate`,
  getLockInvoices: (): string => `${generatePaymentsBffUrl()}/ap-invoice-lock`,
  getVendorsPath: (companyId: string): string =>
    `${generatePaymentsBffUrl()}/vendors/async/${companyId}`,
  getVendorsServicePath: (companyId: string): string =>
    `${generatePaymentsServiceUrl()}/vendors/${companyId}`,
  getCashInBankAccountsPath: (companyId: string): string =>
    `${generatePaymentsServiceUrl()}/cash-in-bank-accounts/${companyId}`,
  getCashInBankAccounts: (storeId: string, printerInfo: boolean): string =>
    `${generatePaymentsBffV2Url()}/cash-in-bank-accounts/${storeId}?includePrinterInfo=${printerInfo}`,
  getApCheckApprovalsPath: (companyId: string): string =>
    `${generatePaymentsServiceUrl()}/ap-check/${companyId}/approvals`,
  getApCheckPrintPath: (companyId: string): string =>
    `${generatePaymentsServiceUrl()}/vendors/async/${companyId}/print-checks`,
  getApCheckVoidPath: (companyId: string): string =>
    `${generatePaymentsServiceUrl()}/ap-check/async/${companyId}/void-multi`,
  getPrintIsAuthorizedPath: (companyId: string): string =>
    `${generatePaymentsServiceUrl()}/ap-check/${companyId}/approvals/print-is-authorized`,
  getPrintersWithCheckNoPath: (cib: string): string =>
    `${generatePaymentsServiceUrl()}/getPrintersWithCheckNumber/${cib}?defaultPrinter=true `,
  GET_PRINTERS_LIST: (storeId: string): string =>
    `${getAPIBaseUrlForPrintService(
      APP_ENV
    )}/usn-print-services/v1/printers?storeId=${storeId}&paperSize=all`,
  PRINT_DOC: `${getAPIBaseUrlForPrintService(
    APP_ENV
  )}/usn-print-services/v1/print`,
  getArchiveUrlPath: (
    companyId: string,
    fileExtension: string,
    paymentMethod: string
  ): string =>
    `${generatePaymentsBffUrl()}/archive/${companyId}/${paymentMethod}?fileExtension=${fileExtension}`,
  updateInvoiceDescription: (): string =>
    `${generatePayablesUrl()}/ap-invoices/v2/update-invoice-description`,
  getGlCalendar: (storeId: string): string =>
    `${generateCommonBffUrl()}/common-bff/gl-calendar/${storeId}`,
  getHighVolumeVendorsToBePaidPath: (storeId: string): string =>
    `${generatePaymentsBffUrl()}/ap-payments/to-be-paid/${storeId}`,
  getHighVolumeVendorsNeedsAuthorizationPath: (storeId: string): string =>
    `${generatePaymentsBffUrl()}/ap-payments/needs-authorization/${storeId}`,
  getHighVolumeVendorsPrintChecksPath: (storeId: string): string =>
    `${generatePaymentsBffUrl()}/ap-payments/print-checks/${storeId}`,
  getInvoiceStatePath: (storeId: string, state: InvoiceState): string =>
    `${generatePaymentsBffUrl()}/ap-payments/invoice-state/${storeId}/${state}`
};

export const METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH'
};

export const STATUS = {
  SUCCESS: 200,
  ERROR: 500,
  UNAUTHORIZED: 401
};

export const POLLING_STATUS: Record<string, CheckStatus> = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  ERROR: 'ERROR'
};
export const POLLING_REFRESH_INTERVAL = 2000;

export const OKTA_CLIENT_ID: CustomAPIService = {
  develop: '0oa14f8o2ai2OzeYr0h8',
  stage: '0oa14f8o2ai2OzeYr0h8',
  perf: '0oa28rtc0prcOHOe30h8',
  master: '0oalivlqyjQ1RN15v1t7'
};

export const OKTA_REDIRECT_URI = `${window.location.origin}/login/callback`;

export const OKTA_REDIRECT_URI_FOR_MFE = window.location.origin;

export const OKTA_ISSUER: CustomAPIService = {
  develop: 'https://connectcdk-dit.oktapreview.com/oauth2/default',
  stage: 'https://connectcdk-dit.oktapreview.com/oauth2/default',
  perf: 'https://connectcdk-dev.oktapreview.com/oauth2/default',
  master: 'https://connectcdk.okta.com/oauth2/default'
};

export const OKTA_AUTHORIZE_URIS: CustomAPIService = {
  develop: 'https://login-dit.connectcdk.com/login/authorize',
  stage: 'https://login-dit.connectcdk.com/login/authorize',
  perf: 'https://login-perf.connectcdk.com/login/authorize',
  master: 'https://login.connectcdk.com/login/authorize'
};

export const API_ERROR_MSG: ObjectTypes = {
  MISSING_COMPANY_ID: 'Missing Company ID',
  MISSING_STORE_ID: 'Missing Store ID'
};

export const JAVA_EXCEPTION_STRING = 'java.lang.Exception:';

export const JAVA_EXCEPTION_ERROR = 'Accounting Setups not found';
